export default {
  SOCIETIES: 'SOCIETIES',
  FILE: 'FILE',
  MANUAL: 'MANUAL',
};
